var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',{attrs:{"state":_vm.state,"value":_vm.value,"placeholder":_vm.$t('strategy.onepage.horizons.description', {
            index: `${_vm.index}`,
        })},on:{"input":function($event){return _vm.$emit('update:value', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }